import React, { useEffect } from 'react';

export const TrustPilotWidget = () => {
  const ref = React.useRef(null);

  useEffect(() => {
    // Boiler-plate code from trustpilot support site
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale="en-US"
      data-template-id="539ad0ffdec7e10e686debd7"
      data-businessunit-id="5a395226b894c90dd4914b9e"
      data-style-height="700px"
      data-style-width="100%"
      data-theme="light"
      data-stars="4,5"
      data-review-languages="en"
    >
      <a
        href="https://www.trustpilot.com/review/www.singlecare.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
};
